import { FileText, Home, Image, Music, Package, Palette, Type, Video, type LucideIcon } from 'lucide-react';

import type { Material } from './types';

/** The sections of one brand, in the order the sidebar lists them. Each is a path segment. */
export const BRAND_TABS = [
  'overview',
  'logo',
  'colour',
  'fonts',
  'visual-elements',
  'audio',
  'files',
  'products',
] as const;
export type BrandTab = (typeof BRAND_TABS)[number];

export const BRAND_TAB_ICONS: Record<BrandTab, LucideIcon> = {
  overview: Home,
  logo: Image,
  colour: Palette,
  fonts: Type,
  'visual-elements': Video,
  audio: Music,
  files: FileText,
  products: Package,
};

/** The tab that completes one mandatory material. */
export const TAB_OF_MATERIAL: Record<Material, BrandTab> = {
  logos: 'logo',
  colours: 'colour',
  font: 'fonts',
  guidelines: 'files',
};

export function isBrandTab(value: string | undefined): value is BrandTab {
  return BRAND_TABS.some((tab) => tab === value);
}
